// Import for drawer
import { Drawer, Box, IconButton } from "@mui/material";

// Common drawer types
import { IDrawerProps } from "./CommonDrawerTypes";

// Client list component
const CommonDrawer: React.FC<IDrawerProps> = ({
  handleClose,
  children,
  drawerWidth,
  ...drawerProps
}) => {
  return (
    <Drawer
      anchor="right"
      ModalProps={{
        BackdropProps: {
          // Prevent backdrop and escape clicks
          onClick: (e) => e.stopPropagation(),
        },
      }}
      PaperProps={{
        className: "agridrawer",
        sx: { width: drawerWidth, padding: 0, borderRadius: "16px 0 0 16px" },
      }}
      {...drawerProps}
    >
      <Box sx={{ padding: 0 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <IconButton onClick={handleClose}>
            <i className="icon-close" />
          </IconButton>
        </Box>
        <Box>{children}</Box>
      </Box>
    </Drawer>
  );
};

export default CommonDrawer;
